<template>
  <b-modal ref="forgot-password-modal" id="forgot-password-modal" size="sm" hide-footer centered>
    <template slot="modal-header">
      <h4 class="modal-title">Wachtwoord vergeten</h4>
      <button type="button" aria-label="Close" @click="hideModal" class="close">
        <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
      </button>
    </template>
    <template slot="default">
      <div class="col-md-13">
        <span class="comment">
          Vul je e-mailadres in en wij sturen je een link waarmee je je wachtwoord kunt resetten.
        </span>

        <form @submit.prevent="onSubmit" class="mt-2">
          <div class="form-group">
            <label for="forgot-password-email">E-Mailadres</label>
            <input
              id="forgot-password-email"
              type="email"
              class="form-control"
              :class="{'is-invalid': $v.email.$error}"
              v-model="email"
              @blur="$v.email.$touch()"
              autocomplete="email"
              autofocus
            >
            <span v-if="$v.email.$error" class="invalid-feedback" role="alert">
              <strong>Vul a.u.b. uw e-mailades in.</strong>
            </span>
          </div>

          <div
            v-if="forgotPasswordStatus"
            class="col-md-13 alert"
            role="alert"
            :class="{ 'alert-success': forgotPasswordStatus.success, 'alert-danger': !forgotPasswordStatus.success }"
          >
            <strong>{{ forgotPasswordStatus.message }}</strong>
          </div>

          <div class="row justify-content-center">
            <div class="col-md-13 mt-md-3">
              <button
                type="submit"
                class="btn btn-oldevuuren w-100 btn-round"
                :disabled="$v.$invalid"
                :class="{'disabled cursor-not-allowed': $v.$invalid}"
              >
                Wachtwoord aanvragen
                <font-awesome-icon class="font-awesome-icon" v-if="forgotPasswordBusy" icon="spinner" spin/>
              </button>

            </div>

            <div class="row align-content-center mt-2">
              <div class="col-md-13">
                <span class="comment">Geen account?</span>&nbsp;<span @click="register" class="link underline">Meld je aan</span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { email, required } from 'vuelidate/lib/validators'

  import { FORGOT_PASSWORD } from '../../store/types'

  export default {
    props: ['registerParent'],
    data() {
      return {
        email: ''
      }
    },
    validations: {
      email: {
        required,
        email
      }
    },
    computed: {
      forgotPasswordStatus() {
        return this.$store.getters.forgotPasswordStatus
      },
      forgotPasswordBusy() {
        return this.$store.getters.forgotPasswordBusy
      }
    },
    methods: {
      register() {
        this.$refs['forgot-password-modal'].hide()
        this.registerParent()
      },
      showModal() {
        this.$refs['forgot-password-modal'].show()
      },
      hideModal() {
        this.$refs['forgot-password-modal'].hide()
      },
      onSubmit() {
        const formData = {
          email: this.email,
          password: this.password
        }

        this.$store.dispatch(FORGOT_PASSWORD, {
          email: formData.email
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
